
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';

import configurationService from '../../../services/configuration-service.js';
const ViewAgentLimits = () => { 
    const [limit, setLimits] = useState({});
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate()

        const getAgentLimits = () => {
            setLoading(true);
            configurationService.getAgentLimitDetails(id)
                  .then(response => {
                    const data =response.data.data
                    setLimits(data)
                    setLoading(false);
                  })
                  .catch(error => {
                    setLoading(false);
                    try {
                      const errorMessage = error.response.data
                      toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
                    } catch (e){
                      toast.error( MESSAGES.SERVER_ERROR)
                    }
                  });
          }
        useEffect(() => {
            getAgentLimits();
            document.body.style.backgroundImage = '';

            document.body.style.backgroundColor = '#f0f6fa';
            return () => {
              document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
            };
    }, []);
    const back = () => {
      navigate(-1); 
    }
    return(
      <div>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
      <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Agent Limit Details</h4>
      <div className="row ghty" style={{backgroundColor: 'white', height: 'auto', paddingBottom: '20px'}}>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Information</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Limit ID</label>
                      <p>{limit.limit_group_id  || '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Limit Group NAME</label>
                      <p>{limit.limit_group_name  || '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Status</label>
                      <p>{limit.status  || '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Registered on</label>
                      <p>{limit.created_on  || '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Updated on</label>
                      <p>{limit.updated_on  || '-'}</p>
                    </div>
                  </div>
                  {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">STATUS</label>
                      <p>{limit.limit_detail && limit.limit_detail.status ? limit.limit_detail.status : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">STATUS ID</label>
                      <p>{limit.limit_detail && limit.limit_detail.status_id ? limit.limit_detail.status_id : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">COMMISSION GROUP</label>
                      <p>{limit.limit_detail && limit.limit_detail.commision_group ? limit.limit_detail.commision_group : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">COMMISSION GROUP NAME</label>
                      <p>{limit.limit_detail && limit.limit_detail.comm_grp_name ? limit.limit_detail.comm_grp_name : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">CREATED ON</label>
                      <p>{limit.limit_detail && limit.limit_detail.created_on ? limit.limit_detail.created_on : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">CREATED BY</label>
                      <p>{limit.limit_detail && limit.limit_detail.created_by ? limit.limit_detail.created_by : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">UPDATED BY</label>
                      <p>{limit.limit_detail && limit.limit_detail.updated_by ? limit.limit_detail.updated_by : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">APPROVED BY</label>
                      <p>{limit.limit_detail && limit.limit_detail.approved_by ? limit.limit_detail.created_by : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">PROFILE PHOTO</label><br />
                      <img style={{margin: 0}} src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Pay In Limits</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Daily</label>
                      <p>{limit.daily_cash_in_limit ||  '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Weekly</label>
                      <p>{limit.weekly_cash_in_limit ||  '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Monthly</label>
                      <p>{limit.monthly_cash_in_limit ||  '-'}</p>
                    </div>
                  </div>
    
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Pay out Limits</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Daily</label>
                      <p>{limit.daily_cash_out_limit ||  '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Weekly</label>
                      <p>{limit.weekly_cash_out_limit ||  '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Monthly</label>
                      <p>{limit.monthly_cash_out_limit ||  '-'}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Pay In counts</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Daily</label>
                      <p>{limit.daily_cash_in_limit_count ||  '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Weekly</label>
                      <p>{limit.weekly_cash_in_limit_count ||  '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Monthly</label>
                      <p>{limit.monthly_cash_in_limit_count ||  '-'}</p>
                    </div>
                  </div>
              
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Pay Out Counts
</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Daily</label>
                      <p>{limit.daily_cash_out_limit_count ||  '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Weekly</label>
                      <p>{limit.weekly_cash_out_limit_count ||  '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Monthly</label>
                      <p>{limit.monthly_cash_out_limit_count ||  '-'}</p>
                    </div>
                  </div>
           
                </div>
              </div>
            </div>
          </div>
        </div>
        <a style={{width: 'auto', padding: '0px'}} onClick={back}><button className="btn btn-success backbt">Back</button></a>
      </div>
    </div>
    </div>
    
    )
    
    } 
    function mapStateToProps(state) {
        const userData = state.authReducer.user;
        return { userData };
      }
  export default withAuth(connect(mapStateToProps)(ViewAgentLimits));